import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  Button,
  DialogActions,
} from '@mui/material';

import {
  Typography
} from '../../../components/v2/styled';
import { Base } from './Base';

type Props = {
  execute: (e: any) => void;
  open: boolean;
  setOpen: (b:boolean) => void;
};

export const Removal: FunctionComponent<Props> = ({execute, open, setOpen}) => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  // const [open, setOpen] = useState<boolean>(false);

  // useEffect(() => {
  //   setOpen(!hidden);
  // }, [hidden]);

  return (<>
    <Base
      name="alert"
      hidden={!open}
      title={t("general.confirm.delete_title")}
      content={<Typography>{t("general.confirm.delete_content")}</Typography>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Button autoFocus onClick={() => {setOpen(false);}}>{t("general.confirm.actions.cancel")}</Button>
        <Button color="secondary" onClick={(e) => {if (!!execute) execute(e); setOpen(false);}}>{t("general.confirm.actions.destroy")}</Button>
      </DialogActions>}
      open={open}
      setOpen={setOpen}
    />
  </>);
}